import { useEffect } from 'react';
import { eventsController } from './eventsController';
import { TPanelEventIdentifier, TPanelEventCallback } from './types';

/**
 * Este hook permite realizar suscripciones a eventos de paneles. Deberá ser
 * llamado una vez por cada suscripción que desee hacerse dentro de un panel y
 * no se deberán ejecutar acciones para romper las suscripciones hechas, ya que
 * este hook maneja esa lógica de forma automática.
 */
export function usePanelOnEvent<PayloadEvent>(
  distinction: Partial<TPanelEventIdentifier>,
  callback: TPanelEventCallback<PayloadEvent>,
) {
  useEffect(() => {
    const unsuscriber = eventsController.onEvent(distinction, callback);

    return () => {
      unsuscriber();
    };
  });
}
